export const userInputs = [
    {
        id: 1,
        label: "Username",
        type: "text",
        placeholder: "john_doe",
        name: "username",
    },
    {
        id: 2,
        label: "Name and surname",
        type: "text",
        placeholder: "John Doe",
        name: "displayName",
    },
    {
        id: 3,
        label: "Email",
        type: "mail",
        placeholder: "john_doe@gmail.com",
        name: "email",
    },
    {
        id: 4,
        label: "Phone",
        type: "text",
        placeholder: "+1 234 567 89",
        name: "phone",
    },
    {
        id: 5,
        label: "Password",
        type: "password",
        name: "password",
    },
    {
        id: 6,
        label: "Address",
        type: "text",
        placeholder: "Elton St. 216 NewYork",
        name: "address",
    },
    {
        id: 7,
        label: "Country",
        type: "text",
        placeholder: "USA",
        name: "country",
    },
];

export const productInputs = [
    {
        id: 1,
        label: "Title",
        type: "text",
        placeholder: "Apple Macbook Pro",
        name: "title",
    },
    {
        id: 2,
        label: "Description",
        type: "text",
        placeholder: "Description",
        name: "description",
    },
    {
        id: 3,
        label: "Category",
        type: "text",
        placeholder: "Computers",
        name: "category",
    },
    {
        id: 4,
        label: "Price",
        type: "text",
        placeholder: "100",
        name: "price",
    },
    {
        id: 5,
        label: "Stock",
        type: "text",
        placeholder: "in stock",
        name: "stock",
    },
];

export const orderInputs = [
    {
        id: 1,
        label: "Product",
        type: "text",
        placeholder: "Product Name",
        name: "product",
    },
    {
        id: 2,
        label: "Customer",
        type: "text",
        placeholder: "Customer Name",
        name: "customer",
    },
    {
        id: 3,
        label: "Date",
        type: "date",
        name: "date",
    },
    {
        id: 4,
        label: "Amount",
        type: "number",
        placeholder: "Amount",
        name: "amount",
    },
    {
        id: 5,
        label: "Status",
        type: "text",
        placeholder: "Pending/Approved",
        name: "status",
    },
];

export const deliveryInputs = [
    {
        id: 1,
        label: "Product",
        type: "text",
        placeholder: "Product Name",
        name: "product",
    },
    {
        id: 2,
        label: "Destination",
        type: "text",
        placeholder: "Destination Address",
        name: "destination",
    },
    {
        id: 3,
        label: "Status",
        type: "text",
        placeholder: "In Transit/Delivered",
        name: "status",
    },
];
